/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import Config from "data/config";

const ComponentDebug = (props) => {
    
    const components = props?.components;
    const settings = props?.settings;
    const schema = props?.schema;
    
    if (Config.Debug.enableComponentDebug) {
        return (
            <div style={{ maxWidth: "960px" }}>
                <details>
                    <summary>Value</summary>
                    <pre style={{ fontSize: "9px", border: "1px solid #999999", maxWidth: "960px", overflowX: "auto" }}>
                        {JSON.stringify(components, null, 2)}
                    </pre>
                </details>
                <details>
                    <summary>Settings</summary>
                    <pre style={{ fontSize: "9px", border: "1px solid #999999", maxWidth: "960px", overflowX: "auto" }}>
                        {JSON.stringify(settings, null, 2)}
                    </pre>
                </details>
                <details>
                    <summary>Schema</summary>
                    <pre style={{ fontSize: "9px", border: "1px solid #999999", maxWidth: "960px", overflowX: "auto" }}>
                        {JSON.stringify(schema, null, 2)}
                    </pre>
                </details>
            </div>
        );
    } else {
        return null;
    }
};

ComponentDebug.displayName = "ComponentDebug";
export { ComponentDebug };
